import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/services/auth.service';
import { CurrentUserService } from 'src/app/core/services/current-user.service';

@Component({
  selector: 'app-cambiar-password-forzado',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './cambiar-password-forzado.component.html',
  styleUrl: './cambiar-password-forzado.component.css'
})
export class CambiarPasswordForzadoComponent{
form: FormGroup;
  error = '';
  success = '';
  loading = false;
  usuarioId: number = 0;
  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private currentUserService: CurrentUserService) {
    this.form = this.fb.group({
      nuevaPassword: ['', Validators.required],
      confirmarPassword: ['', Validators.required],
    });
  }
  

  cambiar() {
     const userId = this.currentUserService.getUsuarioId();
    if (userId) {
      this.usuarioId += userId
    } 
    if (this.form.invalid) return;

    const { nuevaPassword, confirmarPassword } = this.form.value;
    if (nuevaPassword !== confirmarPassword) {
      this.error = 'Las contraseñas no coinciden';
      return;
    }

    this.loading = true;
    this.authService.cambiarPasswordForzado(this.usuarioId,nuevaPassword).subscribe({
      next: (res) => {
        localStorage.setItem('token', res.token ?? '');
        localStorage.setItem('userId', res.userId.toString());
        localStorage.setItem('userName', JSON.stringify(res.nombre));
        localStorage.setItem('email', res.email ?? '');
        localStorage.setItem('debeCambiarPassword', res.debeCambiarPassword ? 'true' : 'false');
        this.router.navigate(['/dashboard']);
      },
      error: () => {
        this.error = 'Error al actualizar la contraseña';
        this.loading = false;
      }
    });
  }
}
